// define subscription plans for dev and prod
// @see `api/actions/dev/seeds/subscriptionPlan.ts` for more information
// const examplePlansFromSeed = {
//   freemium: {
//     id: "1",
//     name: "Freemium",
//     price: 0,
//   },
//   leaked: {
//     id: "2",
//     name: "Leaked",
//     price: 29,
//   },
//   blocking: {
//     starter: {
//       id: "3",
//       name: "Blocking Starter",
//       price: 99,
//     },
//     growth: {
//       id: "4",
//       name: "Blocking Growth",
//       price: 189,
//     },
//     pro: {
//       id: "5",
//       name: "Blocking Pro",
//       price: 299,
//     },
//   }
// }

const prodSubscriptionPlans = {
  blocking: {
    growth: {
      id: 96,
      name: "Blocking Growth",
      price: 189,
    },
    pro: {
      id: 97,
      name: "Blocking Pro",
      price: 299,
    },
    starter: {
      id: 95,
      name: "Blocking Starter",
      price: 99,
    },
  },
  freemium: {
    id: 23,
    name: "Freemium",
    price: 0,
  },
  leaked: {
    id: 2,
    name: "Leaks Only",
    price: 29,
  },
};

const stagingSubscriptionPlans = {
  blocking: {
    growth: {
      id: 6,
      name: "Blocking Growth",
      price: 189,
    },
    pro: {
      id: 3,
      name: "Blocking Pro",
      price: 299,
    },
    starter: {
      id: 5,
      name: "Blocking Starter",
      price: 99,
    },
  },
  freemium: {
    id: 22,
    name: "Freemium",
    price: 0,
  },
  leaked: {
    id: 1,
    name: "Leaks Only",
    price: 29,
  },
};

const testingSubscriptionPlans = {
  blocking: {
    growth: {
      id: 105,
      name: "Blocking Growth",
      price: 189,
    },
    pro: {
      id: 106,
      name: "Blocking Pro",
      price: 299,
    },
    starter: {
      id: 104,
      name: "Blocking Starter",
      price: 99,
    },
  },
  freemium: {
    id: 102,
    name: "Freemium",
    price: 0,
  },
  leaked: {
    id: 103,
    name: "Leaks Only",
    price: 29,
  },
};

const tanmayDevSubscriptionplans = {
  blocking: {
    growth: {
      id: 107,
      name: "Blocking Growth",
      price: 189,
    },
    pro: {
      id: 108,
      name: "Blocking Pro",
      price: 299,
    },
    starter: {
      id: 82,
      name: "Blocking Starter",
      price: 99,
    },
  },
  freemium: {
    id: 80,
    name: "Freemium",
    price: 0,
  },
  leaked: {
    id: 81,
    name: "Leaks Only",
    price: 29,
  },
};

const ricardoDevSubscriptionplans = {
  blocking: {
    growth: {
      id: 99,
      name: "Blocking Growth",
      price: 189,
    },
    pro: {
      id: 100,
      name: "Blocking Pro",
      price: 299,
    },
    starter: {
      id: 79,
      name: "Blocking Starter",
      price: 99,
    },
  },
  freemium: {
    id: 77,
    name: "Freemium",
    price: 0,
  },
  leaked: {
    id: 78,
    name: "Leaks Only",
    price: 29,
  },
};

const aurelienQswFromRicardoDevPlans = {
  blocking: {
    growth: {
      id: "4",
      name: "Blocking Growth",
      price: 189,
    },
    pro: {
      id: "5",
      name: "Blocking Pro",
      price: 299,
    },
    starter: {
      id: "3",
      name: "Blocking Starter",
      price: 99,
    },
  },
  freemium: {
    id: "1",
    name: "Freemium",
    price: 0,
  },
  leaked: {
    id: "2",
    name: "Leaks Only",
    price: 29,
  },
};

const alexDevSubscriptionplans = {
  blocking: {
    growth: {
      id: 129,
      name: "Blocking Growth",
      price: 189,
    },
    pro: {
      id: 130,
      name: "Blocking Pro",
      price: 299,
    },
    starter: {
      id: 128,
      name: "Blocking Starter",
      price: 99,
    },
  },
  freemium: {
    id: 126,
    name: "Freemium",
    price: 0,
  },
  leaked: {
    id: 127,
    name: "Leaks Only",
    price: 29,
  },
};

const getSubscriptionPlans = () => {
  if (window.gadgetConfig.environment === "staging") {
    return stagingSubscriptionPlans;
  } else if (window.gadgetConfig.environment === "testing") {
    return testingSubscriptionPlans;
  } else if (window.gadgetConfig.environment === "tanmay-dev") {
    return tanmayDevSubscriptionplans;
  } else if (window.gadgetConfig.environment === "ricardo-dev") {
    return ricardoDevSubscriptionplans;
  } else if (window.gadgetConfig.environment === "alex-dev") {
    return alexDevSubscriptionplans;
  } else if (window.gadgetConfig.environment === "aurelien-qsw-from-ricardo-dev") {
    return aurelienQswFromRicardoDevPlans;
  } else {
    return prodSubscriptionPlans;
  }
};

export const subscriptionPlans = getSubscriptionPlans();

export const blockingOptions = [
  { label: "Select", value: "Select" },
  { label: "2,500", value: "small" },
  { label: "5,000", value: "mid" },
  { label: "10,000", value: "big" },
];
